import React, { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { LiveLeaderboardBanner } from '../LiveLeaderboardBanner/LiveLeaderboardBanner';
import { WelcomeBanner } from '../WelcomeBanner/WelcomeBanner';
import { Participant } from '../../types';
import { useLeaderboardParticipants } from '../../../../hooks/useLeaderboardParticipants';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { WinBigBanner } from '../../../../Components/WinBigBanner/WinBigBanner';
import './LeaderboardHeader.scss';
import { ProgressOverview } from '../../../../Components/ProgressOverview/ProgressOverview';
import { LeaderboardEventSummary } from '../../../../api/leaderboard-events';

interface LeaderboardHeaderProps {
  startDate?: string;
  endDate?: string;
  selectedEventId?: number;
  summary?: LeaderboardEventSummary;
}

export const LeaderboardHeader: React.FC<LeaderboardHeaderProps> = ({
  startDate = '10',
  endDate = '22',
  selectedEventId,
  summary,
}) => {
  const { participants } = useLeaderboardParticipants(selectedEventId);
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const podiumParticipants: Participant[] = useMemo(() => {
    return (participants || []).slice(0, 3).map((p) => ({
      id: p.id,
      name: `${p.firstName} ${p.lastName}`.trim(),
      position: p.rank,
    }));
  }, [participants]);

  const progressData = summary
    ? [
      {
        label: 'Total Hours',
        value: summary.totalHours,
        max: summary.milestone,
      },
      {
        label: 'Total Reviews',
        value: summary.reviewsCount,
        max: summary.reviewMilestone,
      },
    ]
    : undefined;

  return (
    <div className="leaderboard-header">
      {isMobile ? (
        <Swiper
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
          spaceBetween={16}
          slidesPerView={1}
          touchRatio={1}
          resistance={true}
          resistanceRatio={0.85}
          allowTouchMove={true}
          threshold={5}
        >
          <SwiperSlide>
            <WelcomeBanner startDate={startDate} endDate={endDate} />
          </SwiperSlide>
          <SwiperSlide>
            <WinBigBanner />
          </SwiperSlide>
          <SwiperSlide>
            <LiveLeaderboardBanner participants={podiumParticipants} />
          </SwiperSlide>
          <SwiperSlide>
            <ProgressOverview data={progressData} />
          </SwiperSlide>
        </Swiper>
      ) : (
        <>
          <LiveLeaderboardBanner participants={podiumParticipants} />
          <WelcomeBanner startDate={startDate} endDate={endDate} />
        </>
      )}
    </div>
  );
};
